export default "__VITE_ASSET__99397d3e__"